import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import { queryClient } from "./backend/queryClient";
import "./index.css";

let AgentationDevTools: React.ComponentType = () => null;
if (
  process.env.NODE_ENV === "development" &&
  process.env.REACT_APP_AGENTATION_ENABLED === "true"
) {
  const agentationModule =
    require("./components/dev/AgentationDevTools") as typeof import("./components/dev/AgentationDevTools");
  AgentationDevTools = agentationModule.AgentationDevTools;
}

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Missing #root application mount");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
      <AgentationDevTools />
    </QueryClientProvider>
  </React.StrictMode>,
);
